// useLastClicked.ts
import { useState, useEffect } from 'react';
import { formatDistanceToNow } from 'date-fns';
import ja from 'date-fns/locale/ja';

export const useLastClicked = () => {
  const [lastClicked, setLastClicked] = useState<Date | null>(null);
  const [timeSinceLastClick, setTimeSinceLastClick] = useState<string>('');

  useEffect(() => {
    if (lastClicked) {
      setTimeSinceLastClick("(" + formatDistanceToNow(lastClicked, { locale: ja }) + '前)');
    }
    const intervalId = setInterval(() => {
      if (lastClicked) {
        setTimeSinceLastClick("(" + formatDistanceToNow(lastClicked, { locale: ja }) + '前)');
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [lastClicked]);

  return {
    lastClicked,
    timeSinceLastClick,
    setLastClicked
  };
};
